module.exports = __webpack_public_path__ + "media/wooden-bell.1a240f69.wav";